import { parseServed, parseStations } from './nr-stations.ts';
import type { NrStation } from './nr-stations.ts';

export interface NrJsonResponse {
  readonly ok: boolean;
  readonly status: number;
  readonly json: () => Promise<unknown>;
}

export interface NrStationsLoad {
  readonly stations: readonly NrStation[];
  readonly served: ReadonlySet<string> | null;
}

// Load both station inputs as one generation. Leaving London invalidates the
// generation, so late responses cannot put its station layer back on the map.
export async function loadNrStations(
  fetchJson: (url: string) => Promise<NrJsonResponse>,
  stationsUrl: string,
  servedUrl: string,
  current: () => boolean,
): Promise<NrStationsLoad | null> {
  const [stationsResponse, servedResponse] = await Promise.all([
    fetchJson(stationsUrl),
    fetchJson(servedUrl).catch(() => null),
  ]);
  if (!current()) return null;
  if (!stationsResponse.ok) throw new Error(`HTTP ${stationsResponse.status}`);
  const [stationsData, servedData] = await Promise.all([
    stationsResponse.json(),
    servedResponse?.ok === true ? servedResponse.json().catch(() => null) : Promise.resolve(null),
  ]);
  if (!current()) return null;
  return {
    stations: parseStations(stationsData),
    served: parseServed(servedData),
  };
}
